<template>
  <v-card flat class="px-1 mt-1">
    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="8" class="pa-0">
          <h3 v-if="projectDrawingObj.isProjectDrawing" class="pa-1 pl-2">{{$t('message.projects.project')}}: <router-link :to="`/projects/${projectId}`">{{ projectFullName }}</router-link></h3>
        </v-col>
        <v-col cols="4" class="pa-0 text-end pr-5 py-1">
          <v-btn v-if="checklistEnable" @click="goChecklist()" class="primary">{{ $t('message.checklist.title') }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <scroll-list v-if="renderScrollList" :key="reInit" id="drawingScrollList" :payload="scrollListPayload"></scroll-list>
    <div ref="lgContainer" style="display:none"></div>
  </v-card>
</template>
<script>
import PermissionsMixin from '@/mixins/permissions'
import { hostAppApi } from '@/plugins/axios_settings'
import { mapGetters } from 'vuex'
import DocumentGalleryMixin from '@/mixins/documentGallery'
export default {
  mixins: [PermissionsMixin, DocumentGalleryMixin],
  data () {
    return {
      projectDrawingObj: {
        isProjectDrawing: true,
        projectId: 0
      },
      listOfStatus: [this.$t('message.deviation.registered'), this.$t('message.deviation.process'), this.$t('message.deviation.closed')],
      scrollListPayload: {
        width: 120,
        module: '',
        loading: false,
        moduleTitle: 'message.layout.drawing',
        addBtnTo: '',
        editHandler: null,
        actionSize: '0',
        pagination: {},
        list: [],
        totalCount: 0,
        itemHeaders: [
          'message.projectFeature.drawingNumber',
          'message.projects.drawingGroup',
          'message.deviation.description',
          'Status'
        ],
        items: [],
        storeIndex: 'PROJECT_DRAWING_INDEX',
        isLivePagination: true,
        hasDelete: true,
        hasNoNext: true,
        page: -1,
        previousSearch: '',
        recordsPerPage: 15,
        drawingTypList: [],
        advanceDrawingTypes: null
      },
      MODULE: 'projectdrawing',
      renderScrollList: false,
      listMaxCallLoaded: false,
      loading: false,
      reInit: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.common.PROJECT_DRAWING_INDEX) ? this.$store.state.common.PROJECT_DRAWING_INDEX : { itemsPerPage: 6, page: 1 },
      projectId: parseInt(this.$route.params.project_id),
      hostUserId: this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0,
      projectFullName: '',
      userRole: JSON.parse(window.localStorage.getItem('UserRole')),
      checklistEnable: false
    }
  },
  computed: {
    ...mapGetters(['getHostRefApi', 'userId', 'userDetails']),
    scrollListItems () {
      /* `advanceDrawingTypes` arrives after this config is built (async
         project_drawing/create call), so `hide` and `cols` are functions that
         VirtualScrollList evaluates against the live payload. Without the
         Drawing Group column the first column takes its width: 6+3+3 = 12. */
      return [{
        value: 'drawning_nr',
        class: 'pa-0 pa-1 text-justify',
        cols: (payload) => payload.advanceDrawingTypes ? '4' : '6',
        spanClass: 'body pl-2 scroll-list-first-col',
        isParagraph: true,
        prefixIconClick: this.previewDocuments,
        prefixIcon: 'mdi-image-multiple',
        prefixIconSize: 45,
        prefixIconCondition: this.hasDocuments
      }, {
        value: 'drawing_type_name',
        class: 'pa-0 pa-1 text-justify',
        cols: '2',
        spanClass: 'body pl-2',
        hide: (payload) => !payload.advanceDrawingTypes,
        isParagraph: true
      }, {
        value: 'description',
        class: 'pa-0 pa-1 text-justify',
        cols: '3',
        spanClass: 'body pl-2',
        isParagraph: true
      }, {
        value: '',
        cols: '3',
        class: 'pa-0 my-auto',
        rowClass: 'mt-1',
        subItems: [{
          value: 'is_completed',
          items: [],
          class: 'pa-0',
          cols: '12',
          spanClass: 'body'
        }]
      }]
    }
  },
  components: {
    'scroll-list': () => import('@/components/VirtualScrollList.vue')
  },
  created () {
    this.MODULE = 'projectdrawing'
    this.scrollListPayload.items = this.scrollListItems
    this.scrollListPayload.editHandler = (item) => {
      this.$router.push(`/projects/${this.projectId}/drawing/action/${item.id}`)
    }
    this.scrollListPayload.addBtnTo = `/projects/${this.projectId}/drawing/action`
  },
  beforeMount () {
    this.getDrawingTypes()
  },
  mounted () {
    var listOfStatus = [
      { text: this.$t('message.common.ready_for_production'), value: 1 },
      { text: this.$t('message.common.production'), value: 2 },
      { text: this.$t('message.common.on_hold'), value: 3 },
      { text: this.$t('message.common.finished'), value: 4 }
    ]
    if (this.userRole && this.userRole.name && this.userRole.name === 'User') {
      this.scrollListPayload.items[3].subItems[0].items = listOfStatus
    } else {
      listOfStatus.push({ text: this.$t('message.common.archived'), value: 5 })
      this.scrollListPayload.items[3].subItems[0].items = listOfStatus
    }
    this.scrollListPayload.module = this.MODULE
    this.getListHandler()
    const text = 'message.common.deleteSuccess'
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { url: `project_drawing/${data.id}?user_id=${parseInt(this.hostUserId)}&project_id=${this.projectId}`, isSingle: true, module: this.MODULE, fromHostApi: true }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.listMaxCallLoaded = false
        this.scrollListPayload.page = -1
        this.scrollListPayload.list = []
        this.getListHandler()
      }
    })
    this.$eventBus.$on('loadList', (data) => {
      this.getListHandler(data)
    })
  },
  methods: {
    getListHandler (search) {
      if (search && (search !== this.scrollListPayload.previousSearch)) {
        this.scrollListPayload = { ...this.scrollListPayload, ...{ list: [], page: -1, previousSearch: search, totalCount: 0 } }
        this.listMaxCallLoaded = false
      }
      if (!search && this.scrollListPayload.previousSearch) {
        this.scrollListPayload = { ...this.scrollListPayload, ...{ list: [], page: -1, previousSearch: '', totalCount: 0 } }
        this.listMaxCallLoaded = false
      }
      if (this.listMaxCallLoaded) return
      this.scrollListPayload.loading = true
      this.scrollListPayload.module = this.MODULE
      this.scrollListPayload.page++
      const model = {
        start: (this.scrollListPayload.page * this.scrollListPayload.recordsPerPage),
        length: this.scrollListPayload.recordsPerPage
      }
      let url = `${this.getHostRefApi}project_drawing?only_items=1&start=${model.start}&length=${model.length}`
      if (search) url += `&search=${search}`
      url += `&project_id=${this.projectId}`
      hostAppApi.get(url)
        .then(response => {
          this.checklistEnable = response.data.checklist_enable
          let { data, recordsFiltered, projectFullName } = response.data
          this.scrollListPayload.total = recordsFiltered
          const transformData = {
            date: { list: ['deadline'], from: 'YYYY-MM-DD', to: 'DD.MM.YYYY' }
          }
          data = this.$formatter.formatListModel(data, transformData)
          data = data.map(value => { return { ...value, status: this.listOfStatus[value.status - 1] } })
          this.scrollListPayload.list = [...this.scrollListPayload.list, ...data]
          if (data.length) this.scrollListPayload.totalCount = recordsFiltered
          if (this.scrollListPayload.totalCount === this.scrollListPayload.list.length) this.listMaxCallLoaded = true
          this.projectFullName = projectFullName
          if (this.reInit === 0) this.reInit++
        }).finally(() => {
          this.scrollListPayload.loading = false
          if (this.scrollListPayload.page === 0) this.renderScrollList = true
        })
    },
    getDrawingTypes () {
      hostAppApi.get(`${this.getHostRefApi}project_drawing/create?user_id=${this.hostUserId}&project_id=${this.projectId}`)
        .then((response) => {
          if (response && response.data && response.data.drawing_types) {
            this.drawingTypList = response.data.drawing_types
          }
          if (response.data && response.data.advance_drawing) {
            this.scrollListPayload.advanceDrawingTypes = true
          } else {
            this.scrollListPayload.advanceDrawingTypes = false
          }
        })
    },
    documentEditUrl (item) {
      return `${this.getHostRefApi}project_drawing/${item.id}/edit?user_id=${this.hostUserId}&project_id=${this.projectId}`
    },
    goChecklist () {
      this.$router.push(`/projects/${this.$route.params.project_id}/checklists?moduleName=${this.$route.name}`)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('loadList')
  }
}
</script>
